import ProductCard from '~/src/common/components/GridCard/ProductCard';
import {
  isProductCardSource,
  isRecipeCardSource,
} from '~/src/common/components/GridCard/ProductCard/types';
import RecipeCard from '~/src/common/components/GridCard/RecipeCard/RecipeCard';
import { GridCardFormat } from '~/src/common/components/GridCard/types';
import { CardInfoWithoutPositionProperties } from '~/src/common/services/Tracker';
import { ClickAddToCartProperties } from '~/src/common/services/Tracker/generated';
import { ATCSource, ATCSourceFrom } from '~/src/screens/CatalogContent/ContentScreen/types';
import { isMarketingCard, isProduct, isRecipe } from '~/src/typings/products/guards';
import { CatalogItem } from '~/src/typings/products/types';

import MarketingCard from '../GridCard/MarketingCard';

interface Props {
  item: CatalogItem;
  eventSource: ClickAddToCartProperties['product event source'];
  source: ATCSource | ATCSourceFrom;
  categoryName?: string;
  subcategory?: { id: string; name: string };
  recipeTypeId?: string;
  format?: GridCardFormat;
  onRefresh?: () => Promise<unknown>;
  onClick?: (product: CatalogItem) => void;
  analyticsProperties: CardInfoWithoutPositionProperties;
}

const CardDispatcher = ({
  item,
  eventSource,
  source,
  categoryName,
  subcategory,
  recipeTypeId,
  onRefresh,
  onClick,
  analyticsProperties,
  format = 'card_ratio',
}: Props) => {
  if (isProduct(item) && isProductCardSource(source)) {
    return (
      <ProductCard
        key={item.id}
        product={item}
        source={source}
        eventSource={eventSource}
        categoryName={categoryName}
        subcategory={subcategory}
        onRefresh={onRefresh}
        onProductCardClick={() => onClick?.(item)}
        analyticsProperties={{
          'product position in the list': item.indexes.byType,
          'card position in the list': item.indexes.global,
          ...analyticsProperties,
        }}
      />
    );
  }

  if (isRecipe(item) && isRecipeCardSource(source)) {
    return (
      <RecipeCard
        name={item.name}
        image={item.images[0]}
        slug={item.slug}
        tag={item.recipeType}
        eventSource={subcategory?.name ?? categoryName ?? eventSource ?? ''}
        source={source}
        onClick={() => onClick?.(item)}
        categoryName={categoryName}
        subcategory={subcategory}
        recipeTypeId={recipeTypeId}
        format={format}
      />
    );
  }

  if (isMarketingCard(item)) {
    return (
      <MarketingCard
        customContent={item}
        key={item.id}
        analyticsProperties={{
          'card position in the list': item.indexes.global,
          'category name': categoryName ?? undefined,
          'subcategory name': subcategory?.name ?? undefined,
          ...analyticsProperties,
        }}
        format={format}
      />
    );
  }

  // FIXME: Ajouter un type check pour s'assurer que le type ici est never
  // Nécessite au préalable un refacto complet des types d'items
  return null;
};

export default CardDispatcher;
